module.exports = __webpack_public_path__ + "img/fragile_select.4c379362.png";